import type { FC, ReactNode } from 'react';
import { QueryErrorResetBoundary as QueryErrorResetBoundaryRQ } from '@tanstack/react-query';
import type { QueryErrorResetBoundaryFunction } from '@tanstack/react-query';

interface Props {
    children: QueryErrorResetBoundaryFunction | ReactNode;
}

export const QueryErrorResetBoundary: FC<Props> = ({ children }) => {
    return <QueryErrorResetBoundaryRQ>{children}</QueryErrorResetBoundaryRQ>;
};
